import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.order;

export const orderSelectors = {
  orderContent: createSelector(selector, (state) => state.orderContent),
  orderHistories: createSelector(selector, (state) => state.orderHistory),
};
